import React from 'react';
import {TouchableOpacity, View} from 'react-native';
import {styles} from "./InvestFlowRadioButtonViewStyle";

interface InvestFlowRadioButtonViewProps {
    radioState: boolean;
    setRadioState: (newState: boolean) => void;
    children: React.ReactNode;
}

export const InvestFlowRadioButtonView = ({radioState, setRadioState, children}: InvestFlowRadioButtonViewProps) => {

    return (
        <View style={[styles.page]}>
            <TouchableOpacity onPress={() => setRadioState(!radioState)} style={[styles.radioButton]}>
                <View style={[styles.outerRadioCircle]}>
                    <View style={[styles.innerRadioCircle, {backgroundColor: radioState ? 'rgb(255, 198, 70)' : 'transparent'}]}/>
                </View>
            </TouchableOpacity>
            {children}
        </View>
    );
}

export default InvestFlowRadioButtonView;